import React from 'react';
import { ListItem, ListItemAvatar, Avatar, ListItemText, Divider } from '@material-ui/core';
import { Unidades, Reais } from '../../components/numberUtils';
import { Venda } from '../../models/venda';

export const ListItemProduto = (props: Venda) => {
  return <div key={props.codigo}>
    <ListItem>
      <ListItemAvatar>
        <Avatar variant="rounded" style={{ backgroundColor: 'orange' }}>
          {props.codigo.toString()}
        </Avatar>
      </ListItemAvatar>
      <ListItemText secondary={<span> {props.nome}</span>}>
        <span><Unidades valor={props.quantidade} />  </span>
      </ListItemText>
      <ListItemText style={{ textAlign: 'right' }} secondary={<span> {props.contagem} venda(s) </span>}>
        <b style={{ fontSize: '1.1rem' }}><Reais valor={props.totalLiquido} />  </b>
      </ListItemText>
    </ListItem>
    <Divider />
  </div>;
};
